import { Injectable } from '@angular/core';
import hash from 'object-hash';
import { CacheModel } from './cache.model';

@Injectable()
export class CacheService {
    private cache: CacheModel = {};

    set(key: string | object, data: any, group: string | object = null) {
        let objHash = null;
        let objGroup = null;
        if (typeof (key) === 'object') {
            objHash = { ...key };
            key = hash(key);
        }
        if (typeof (group) === 'object') {
            objGroup = { ...group };
            group = hash(group);
        }
        if (this.has(key) && typeof (this.cache[key].data) === 'object' && typeof (data) === 'object') {
            Object.assign(this.cache[key].data, data);
        } else {
            this.cache[key] = {
                objHash,
                objGroup,
                group,
                data
            };
        }
    }

    get(key: string | object) {
        if (typeof (key) === 'object') {
            key = hash(key);
        }
        if (!this.has(key)) {
            return null;
        }
        return this.cache[key].data;
    }

    has(key: string | object) {
        if (typeof (key) === 'object') {
            key = hash(key);
        }
        return !!this.cache[key];
    }

    clear(): void {
        this.cache = {};
    }

    allByGroup(group: string | object) {
        if (typeof (group) === 'object') {
            group = hash(group);
        }
        const results: any[] = [];
        Object.keys(this.cache)
            .filter(key => this.cache[key] && this.cache[key].group === group)
            .forEach(key => results.push(this.cache[key].data));
        return results;
    }

    clearByGroup(group: string | object): void {
        if (typeof (group) === 'object') {
            group = hash(group);
        }
        Object.keys(this.cache).forEach(key => {
            if (this.cache[key].group === group) {
                this.cache[key] = undefined;
            }
        });
    }
}
